import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Sparkles, Lock } from "lucide-react";

const LINKS = [
  { href: "#servicios", label: "Servicios", testid: "nav-servicios-link" },
  { href: "#galeria", label: "Galería", testid: "nav-galeria-link" },
  { href: "#sobre-mi", label: "Sobre Mí", testid: "nav-sobre-mi-link" },
  { href: "#testimonios", label: "Reseñas", testid: "nav-testimonios-link" },
  { href: "#novedades", label: "Novedades", testid: "nav-novedades-link" },
  { href: "#contacto", label: "Contacto", testid: "nav-contacto-link" },
];

export default function Header({ onBook }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow] duration-300 ${
        scrolled ? "glass-header shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto flex items-center justify-between h-16 sm:h-20">
        <a href="#inicio" data-testid="nav-logo" className="flex items-baseline gap-1.5">
          <span className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-obsidian">
            ISI<span className="text-gold">'S</span>
          </span>
          <span className="text-xs sm:text-sm tracking-[0.35em] uppercase text-taupe">Nails</span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm text-cocoa hover:text-gold transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/admin"
            data-testid="nav-panel-link"
            className="inline-flex items-center gap-1.5 text-sm text-taupe hover:text-gold transition-colors duration-200"
          >
            <Lock className="w-3.5 h-3.5" />
            Panel
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => onBook()}
            data-testid="nav-reservar-btn"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-gold hover:bg-gold-dark text-white text-sm font-medium px-5 py-2.5 transition-colors duration-200"
          >
            <Sparkles className="w-4 h-4" />
            Reservar Cita
          </button>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-cocoa"
            aria-label="Menú"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="mobile-menu" className="lg:hidden glass-header border-t border-sand">
          <div className="px-6 py-4 flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base text-cocoa hover:text-gold transition-colors"
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/admin"
              onClick={() => setOpen(false)}
              data-testid="mobile-panel-link"
              className="inline-flex items-center gap-1.5 text-base text-taupe hover:text-gold transition-colors"
            >
              <Lock className="w-4 h-4" />
              Panel (solo propietaria)
            </Link>
            <button
              onClick={() => {
                setOpen(false);
                onBook();
              }}
              data-testid="mobile-reservar-btn"
              className="inline-flex w-fit items-center gap-2 rounded-full bg-gold text-white text-sm font-medium px-5 py-2.5"
            >
              <Sparkles className="w-4 h-4" />
              Reservar Cita
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}
